<template>
  <div>
    <div v-if="loading" class="text-center" style="margin-top: 4rem;">
      <b-spinner label="Loading..."></b-spinner>
    </div>
    <div v-if="!loading">
      <p style="margin: 0.5rem; margin-bottom:1rem;">
        Selecione uma das datas disponíveis para
        <b style="text-transform: capitalize;">{{room.roomName}}</b>
      </p>
      <date-pick
        v-if="showCalendar"
        v-model="date"
        :hasInputElement="false"
        :weekdays="weekdays"
        :months="months"
        nextMonthCaption="Próximo mês"
        prevMonthCaption="Mês anterior"
        :selectableYearRange="selectableYearRange"
        :pickMinutes="false"
        :isDateDisabled="isDateDisabled"
      ></date-pick>
    <b-alert v-model="showErro" variant="danger">{{mensagemErro}}</b-alert>
      <div class="calendario-cancelar" style="margin-top: 1rem;">
        <b-button
          onclick="history.back(-1)"
          variant="secondary"
          v-if="!loading"
          class="btn-sd"
        >Cancelar</b-button>
      </div>
    </div>
    <b-modal id="modal-schedules" @hidden="resetModal" hide-footer>
      <template
        v-slot:modal-title
      >{{weekdaysUTC[new Date(date).getUTCDay()]}}, {{new Date(date).getUTCDate()}} de {{months[new Date(date).getUTCMonth()]}} de {{new Date(date).getUTCFullYear()}}</template>
      <div class="d-block" style="color:var(--main-color-darker-alpha8);">Selecione um dos horários disponíveis:</div>
      <div class="horarios-grid">
        <b-button
          v-for="e in eventsOfDay"
          v-bind:key="e.id"
          class="btn-sd"
          variant="secondary"
          @click="selectSchedule(e)"
        >{{e.dataInicialFormatada.substring(11,16)}}</b-button>
      </div>
    </b-modal>

    <b-modal id="modal-confirmacao" hide-footer>
      <template v-slot:modal-title>Confirmação</template>
      <div class="d-block" style="color:var(--main-color-darker-alpha8);">
        Agendar para:
        <br />
        <b>{{room.roomName}}</b>
        <p
          v-if="selectedEvent.dataInicialFormatada"
        >{{selectedEvent.dataInicialFormatada.substring(8,10) + '/' + selectedEvent.dataInicialFormatada.substring(5,7) + '/' + selectedEvent.dataInicialFormatada.substring(0,4)}} às {{selectedEvent.dataInicialFormatada.substring(11,16)}}</p>
        <hr style="margin: 1.5rem 0rem 1.5rem 0rem;" />
        <div class="botoes-wizard">
          <b-button
            type="button"
            class="btn-sd mr-4"
            variant="secondary"
            @click="$bvModal.hide('modal-confirmacao')"
          >Cancelar</b-button>
          <b-button
            type="button"
            class="btn-sd"
            @click="schedule"
            style="float:right"
            variant="primary"
          >Confirmar</b-button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import DatePick from "vue-date-pick";
import "vue-date-pick/dist/vueDatePick.css";

export default {
  name: "calendario",
  components: { DatePick },
  props: ["idRoom"],
  data() {
    return {
      date: null,
      nextMonthCaption: { type: String, default: "Next month" },
      prevMonthCaption: { type: String, default: "Previous month" },
      setTimeCaption: { type: String, default: "Set time:" },
      weekdays: ["Seg", "Ter", "Qua", "Qui", "Sex", "Sáb", "Dom"],
      weekdaysUTC: ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sáb"],
      months: [
        "Janeiro",
        "Fevereiro",
        "Março",
        "Abril",
        "Maio",
        "Junho",
        "Julho",
        "Agosto",
        "Setembro",
        "Outubro",
        "Novembro",
        "Dezembro"
      ],
      selectableYearRange: 1,
      mensagemErro: null,
      showErro: false,
      availableDates: new Map(),
      showCalendar: false,
      eventsOfDay: null,
      loading: false,
      room: {},
      selectedEvent: {}
    };
  },
  methods: {
    isDateDisabled(date) {
      if (this.isPastDate(date)) {
        return true;
      }

      /* if (this.isSatOrSun(date)) {
        return true;
      }
      */
      if (this.isDateNotAvalible(date)) {
        return true;
      }
      return false;
    },
    isPastDate(date) {
      const currentDate = new Date();
      currentDate.setHours(0, 0, 0, 0);
      return date < currentDate;
    },
    isSatOrSun(date) {
      if (date.getDay() == 6 || date.getDay() == 0) {
        return true;
      }
      return false;
    },
    isDateNotAvalible: function(date) {
      var dia = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      var mes =
        date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1;
      var dateString = date.getFullYear() + "-" + mes + "-" + dia;

      if (this.availableDates.get(dateString) === undefined) {
        return true;
      }
      return false;
    },
    obterEventosDisponiveis: function() {
      this.showErro = false;
      this.loading = true;
      this.$http
        .get(this.$serviceUrl + "/room/" + this.idRoom + "/events")
        .then(
          resp => {
            this.room = resp.body;
            sessionStorage.setItem('selectedRoomName', this.room.roomName);
            this.room.events.forEach(event => {
              var dateString = event.dataInicial.substring(0, 10);
              var eventTemp = this.availableDates.get(dateString);
              if (eventTemp === undefined) {
                var temp = [];
                temp.push(event);
                this.availableDates.set(dateString, temp);
              } else {
                eventTemp.push(event);
              }
            });
            if (this.availableDates.size > 0) {
              this.showCalendar = true;
            } else {
              this.mensagemErro =
                "Infelizmente, não há nenhum dia disponível para agendamento nesta sala.";
              this.showErro = true;
            }
            this.loading = false;
          },
          resp => {
            if (resp.status == 404) {
              this.mensagemErro =
                "Infelizmente, não há nenhum dia disponível para agendamento nesta sala.";
            } else {
              this.mensagemErro = resp.body.message;
            }
            this.showErro = true;
            this.loading = false;
          }
        );
    },
    resetModal() {
      this.date = null;
      this.eventsOfDay = null;
    },
    selectSchedule(e) {
      this.selectedEvent = e;
      sessionStorage.setItem('selectedEvent', JSON.stringify(this.selectedEvent));
      this.$bvModal.hide("modal-schedules");
      this.$bvModal.show("modal-confirmacao");
    },
    schedule: function() {
      this.loading = true;
      this.showErro = false;
      this.$bvModal.hide("modal-confirmacao");
      this.$http
        .put(
          this.$serviceUrl + "/order/event/" + this.selectedEvent.id,
          {},
          {
            headers: {
              Authorization: sessionStorage.getItem("token")
            }
          }
        )
        .then(
          () => {
            sessionStorage.setItem("token", "");
            this.$router.push("/order/step/schedule/success");
          },
          resp => {
            if (resp.status == 404) {
              this.mensagemErro = "Não encontrado";
            } else {
              this.mensagemErro = resp.body.message;
            }
            this.showErro = true;
            this.loading = false;
          }
        );
    }
  },
  watch: {
    date: function() {
      if (this.date != null) {
        this.$bvModal.show("modal-schedules");
        this.eventsOfDay = this.availableDates.get(this.date);
      }
    }
  },
  created() {
    sessionStorage.removeItem('selectedRoomName');
    sessionStorage.removeItem('selectedEvent');
    this.obterEventosDisponiveis();
  }
};
</script>

<style lang="scss">
.vdpCell.selected .vdpCellContent {
  background-color: var(--main-color);
}

.vdpArrowNext::after {
  border-left-color: var(--main-color);
}

.vdpArrowPrev::after {
  border-right-color: var(--main-color);
}
.vdpComponent {
  color: var(--main-color-darker-alpha8);
}

.vdpCell.selectable {
  font-weight: bold;
}
.vdpHeader {
  background-color: #ffffff;
}
.vdpHeadCellContent {
  color: var(--main-color);
}

.vdpPeriodControl button {
  color: var(--main-color);
  font-size: 1rem;
  font-weight: bold;
}
.horarios-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 1rem;
  padding-top: 1rem;
  row-gap: 1rem;
}
#modal-confirmacao.modal-footer {
  border: 0px;
}

@media screen and (max-width: 370px) {
  .horarios-grid {
    grid-template-columns: 100%;
  }
}

@media only screen and (min-width: 1024px){
  #modal-schedules .modal-dialog {
      max-width: 800px;
  }

  .horarios-grid {
    grid-template-columns: 1fr 1fr 1fr 1fr;
}
}
</style>



// WEBPACK FOOTER //
// src/components/Calendario.vue